// User extended data fields — actual values come from CDN (user-fields.json asset)
export const userFields = [];

// User types — actual values come from CDN (user-types.json asset)
// Current types: 'artist' (provider) and 'customer'
export const userTypes = [];
